import { render } from "./EntityList.vue?vue&type=template&id=706fb05b&scoped=true&lang=pug"
import script from "./EntityList.js?vue&type=script&lang=js&external"
export * from "./EntityList.js?vue&type=script&lang=js&external"

import "./EntityList.vue?vue&type=style&index=0&id=706fb05b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706fb05b"]])

export default __exports__